import { getActiveChainId } from '../active'
import type { ChainDefinition } from '../types'
import { ChainId } from '../../sdk'

import { DEFAULT_RPC_URLS } from './defaults'

/**
 * Resuelve la URL JSON-RPC de lectura para un `chainId`.
 * Mono-build (Fase 5): la cadena activa usa `VITE_NETWORK_URL`; el catálogo aporta defaults para el resto.
 */
export function getRpcUrl(chainId: ChainId): string {
  const activeId = getActiveChainId()
  if (chainId === activeId) {
    const fromEnv = import.meta.env.VITE_NETWORK_URL
    if (typeof fromEnv === 'string' && fromEnv.length > 0) {
      return fromEnv
    }
  }

  const fallback = DEFAULT_RPC_URLS[chainId]
  if (!fallback) {
    throw new Error(`[DontPanic] No hay RPC configurado para chainId ${chainId}`)
  }
  return fallback
}

export function getRpcUrlForChain(chain: ChainDefinition): string {
  return getRpcUrl(chain.chainId)
}
